<p>{{ 'enhancedDataServicesDocumentation' | translate }}</p>
<ul>
  @for (doc of documentationList; track trackByLabelKey($index, doc)) {
  <li>
    <a
      target="_blank"
      rel="noopener noreferrer"
      [href]="doc.link"
      [attr.aria-label]="doc?.ariaLabel || ''"
    >
      {{ doc.labelKey | translate }}
    </a>
  </li>
  }
</ul>
